<p *ngIf="!media_id">{{text}}</p>
<app-image-view
    *ngIf="media_id"
    class="media"
    [media_id]="media_id"
    [proportional]="true"
    [paddingBottom]="'100%'"></app-image-view>
